'use client'

import dynamic from 'next/dynamic'
import { FC, ReactNode } from 'react'

import '@/components/Layout/Header/Organisms/Header/Header.scss'
import { UserType } from '@/types/user'

type Props = {
  loginUser: UserType | null
  children: ReactNode
  nextLink?: boolean
  ableToBrowsing?: boolean
}

const HeaderClientLogic = dynamic(() => import('@/components/Layout/Header/Organisms/Header/HeaderClientLogic'), {
  ssr: false,
})

const HeaderClient: FC<Props> = ({ loginUser, nextLink = true, ableToBrowsing = true, children }) => {
  return (
    <>
      <HeaderClientLogic loginUser={loginUser} nextLink={nextLink} ableToBrowsing={ableToBrowsing}>
        {children}
      </HeaderClientLogic>
    </>
  )
}

export default HeaderClient
